import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class JoinCallText extends BaseOption {
  static label = "Join Text";
  static userInterfaceComponent = {
    component: inspectorTools.SIMPLE_INPUT,
  };
  static defaultValue = "Join call";
}
